<template>
  <div class="vant-form-container">
    <van-nav-bar
      :title="$route.meta.title"
      @click-left="$router.back()"
      left-arrow
      :fixed="true"
    />
    <van-form @submit="onSubmit">
      <van-cell-group inset>
        <van-field
          readonly
          clickable
          name="targetDay"
          :value="formState.targetDay"
          label="出院日期"
          placeholder="点击出院日期"
          @click="showDatePicker = true"
        />
        <van-popup v-model="showDatePicker" position="bottom">
          <van-datetime-picker
            type="date"
            :value="currentDate"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="onConfirmDate"
            @cancel="showDatePicker = false"
          />
        </van-popup>

        <van-field name="needBreakfast" label="需要早餐">
          <template #input>
            <van-switch v-model="formState.needBreakfast" size="20" />
          </template>
        </van-field>

        <van-field name="refundTargetDayOrder" label="退款目标日订单">
          <template #input>
            <van-switch v-model="formState.refundTargetDayOrder" size="20" />
          </template>
        </van-field>
      </van-cell-group>

      <div style="margin: 16px;">
        <van-button round block type="primary" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { Dialog } from "vant";

export default {
  name: "VantFormVue2",

  data() {
    return {
      formState: {
        needBreakfast: false,
        targetDay: dayjs().format("YYYY-MM-DD"),
        refundTargetDayOrder: false,
      },
      showDatePicker: false,
      currentDate: dayjs().format("YYYY-MM-DD"),
      minDate: new Date(),
      maxDate: new Date(2025, 11, 31),
    };
  },
  methods: {
    onConfirmDate(value) {
      this.formState.targetDay = this.formatDate(value);
      this.showDatePicker = false;
    },
    formatDate(date) {
      const d = new Date(date);
      let month = "" + (d.getMonth() + 1);
      let day = "" + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    async onSubmit(values) {
      console.log("Form submitted:", values);

      const shopId = localStorage.getItem("shopId");
      let roles = JSON.parse(localStorage.getItem("customerInfoList"));
      const customerId =
        (roles && roles[0].customerId) || localStorage.getItem("customerId");
      // Here you can handle the form submission, e.g., send data to an API

      // 检查时间
      // 是否为空
      if (!values.targetDay) {
        return Dialog.alert({
          title: "提示",
          message: "请选择出院日期",
        });
      }
      // 等于可以
      if (
        values.targetDay !== dayjs().format("YYYY-MM-DD") &&
        dayjs(values.targetDay).isBefore(dayjs(), "day")
      ) {
        return Dialog.alert({
          title: "提示",
          message: "出院日期不能早于当前日期",
        });
      }

      // 二次确认
      await Dialog.confirm({
        title: "提示",
        message: "确认提交吗？",
      });

      const loading = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      try {
        const { data: resData } = await this.$authAjax.post(
          "/api/wxapp/reserve/order/discharge",
          {
            shopId,
            customerId,
            ...values,
          }
        );
        await loading.clear();

        // dialog
        await Dialog.alert({
          title: "提示",
          message: "提交成功",
        });

        // back
        this.$router.back();
      } finally {
        loading.clear();
      }
    },
  },
};
</script>

<style scoped>
.vant-form-container {
  /* padding: 16px; */
  background-color: #f7f8fa;
  padding-top: 56px;
}
</style>
